export const naira = (n) =>
  "₦" + Number(n || 0).toLocaleString("en-NG", { maximumFractionDigits: 0 });

export function healthTone(score) {
  if (score == null) return { label: "—", color: "zinc", tone: "text-zinc-500" };
  if (score >= 75) return { label: "Good", color: "emerald", tone: "text-emerald-600", msg: "Your car dey okay." };
  if (score >= 50) return { label: "Attention", color: "amber", tone: "text-amber-600", msg: "Small things dey need checking." };
  return { label: "Critical", color: "red", tone: "text-red-600", msg: "Abeg, see a mechanic soon." };
}

export const levelColor = {
  green: "bg-emerald-50 text-emerald-700 border-emerald-200",
  amber: "bg-amber-50 text-amber-700 border-amber-200",
  red: "bg-red-50 text-red-700 border-red-200",
};

export const severityColor = {
  Low: "bg-emerald-50 text-emerald-700 border-emerald-200",
  Medium: "bg-amber-50 text-amber-700 border-amber-200",
  Urgent: "bg-red-50 text-red-700 border-red-200",
};

export function daysLabel(days) {
  if (days == null) return "";
  if (days < 0) return `Expired ${Math.abs(days)}d ago`;
  if (days === 0) return "Expires today";
  return `${days} days left`;
}
